export enum FontSizes {
  '3XS' = '3xs',
  '2XS' = '2xs',
  'XS' = 'xs',
  'SM' = 'sm',
  'MD' = 'md',
  'LG' = 'lg',
  'XL' = 'xl',
  '2XL' = '2xl',
  '3XL' = '3xl',
  '4XL' = '4xl',
  '5XL' = '5xl',
  '6XL' = '6xl',
  '7XL' = '7xl',
  '8XL' = '8xl',
  '9XL' = '9xl',
}
